<template>
    <div class="bg">
        <img :src="image" alt="QRCode-image" class="bg-image">
        <div class="bg-title"> 关注“宝来客”学习运营秘籍 </div>
    </div>
</template>
<script>
export default {
    props: {
        placement: "left",
    },
    components: {},
    data() {
        return {
            image: require("../assets/img/home/QRCode.png"),
        }
    },
    mounted() {},
    methods: {},
}
</script>
<style lang="scss" scoped>
.bg {
    text-align: center;
    &-image {
        width: 154px;
        height: 157px;
    }
    &-title {
        font-size: 14px;
        font-weight: bold;
        color: #514D66;
        line-height: 14px;
        margin:0 auto;
        padding: 0px 0px 10px 0px;
    }
}
// .triangle-up {
//     width: 0;
//     height: 0;
//     border-left: 50px solid transparent;
//     border-right: 50px solid transparent;
//     border-top: 100px solid white;
// }
// .triangle-bottom {
//     width: 0;
//     height: 0;
//     border-left: 50px solid transparent;
//     border-right: 50px solid transparent;
//     border-bottom: 100px solid white;
// }
// .triangle-left {
//     width: 0;
//     height: 0;
//     border-top: 50px solid transparent;
//     border-left: 100px solid white;
//     border-bottom: 50px solid transparent;
// }
// .triangle-rigth {
//     width: 0;
//     height: 0;
//     border-top: 50px solid transparent;
//     border-right: 100px solid white;
//     border-bottom: 50px solid transparent;
// }
</style>